import { LinearToneMapping, ReinhardToneMapping, sRGBEncoding, Vector2, WebGLRenderer } from "three"
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import Stats from "three/examples/jsm/libs/stats.module";

export class Renderer extends WebGLRenderer {
    constructor(container = document.querySelector('body'), showStats = false) {

        super({
            antialias: true,
            alpha: true
        });


        this.toneMapping = LinearToneMapping;
        this.outputEncoding = sRGBEncoding;
        this.setSize(container.clientWidth, container.clientHeight);
        this.setPixelRatio(window.devicePixelRatio);
        container.appendChild(this.domElement);


        if (showStats) {
            this.stats = Stats();
            this.stats.dom.style.position = 'absolute';
            this.stats.dom.style.right = '10px';
            this.stats.dom.style.top = '10px';
            this.stats.dom.style.left = '';
            document.body.appendChild(this.stats.dom)
        }
    }
}


export class RendererWithComposer extends Renderer {
    constructor(camera, scene, container = document.querySelector('body'), showStats = true) {

        super(container, showStats);


        this.toneMapping = ReinhardToneMapping;

        const renderScene = new RenderPass(scene, camera);

        this.composer = new EffectComposer(this);
        this.composer.addPass(renderScene);

    }
}